var tileSize = 7;
var editorRatio = 16;

export {tileSize, editorRatio};
